/* Header search dropdown with Shopify predictive search.
   Markup: sections/header.liquid (#SearchDrop). Results: sections/predictive-search.liquid. */
(() => {
  const drop = document.querySelector('[data-search-drop]');
  if (!drop || drop.dataset.init) return;
  drop.dataset.init = '1';

  const input = drop.querySelector('[data-search-input]');
  const live = drop.querySelector('[data-search-live]');
  const fallback = drop.querySelector('[data-search-default]');
  const clearBtn = drop.querySelector('[data-search-clear]');
  const toggles = () => document.querySelectorAll('[data-search-toggle]');
  let timer = null;
  let controller = null;
  let lastFocus = null;

  const isOpen = () => drop.classList.contains('is-open');

  function open() {
    if (isOpen()) return;
    // Close the mega menu and any drawer first.
    document.querySelectorAll('[data-mega].is-open').forEach(m => m.classList.remove('is-open'));
    if (window.TINOR) document.querySelectorAll('.drawer.is-open, .modal.is-open').forEach(el => window.TINOR.close(el));
    lastFocus = document.activeElement;
    const header = document.querySelector('.site-header');
    if (header) document.documentElement.style.setProperty('--header-bottom', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
    drop.classList.add('is-open');
    document.documentElement.classList.add('search-open');
    toggles().forEach(t => t.setAttribute('aria-expanded', 'true'));
    setTimeout(() => input.focus({ preventScroll: true }), 30);
  }

  function close() {
    if (!isOpen()) return;
    drop.classList.remove('is-open');
    document.documentElement.classList.remove('search-open');
    toggles().forEach(t => t.setAttribute('aria-expanded', 'false'));
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function showDefault() {
    live.hidden = true;
    live.innerHTML = '';
    fallback.hidden = false;
    clearBtn.hidden = true;
  }

  async function search(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    const params = new URLSearchParams({
      q,
      'resources[type]': 'product,collection,page,article,query',
      'resources[limit]': '6',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.title,vendor,tag',
      section_id: 'predictive-search'
    });
    drop.classList.add('is-loading');
    try {
      const res = await fetch(drop.dataset.url + '?' + params.toString(), { signal: controller.signal });
      if (!res.ok) throw new Error(res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const results = doc.querySelector('[data-predictive-results]');
      if (input.value.trim() !== q) return; // a newer query is on its way
      live.innerHTML = results ? results.outerHTML : '';
      // No suggestions yet (new stores have no search history): keep the popular searches.
      const side = live.querySelector('.sd-side');
      const popular = fallback.querySelector('.sd-side .sd-group');
      if (side && !side.children.length && popular) side.appendChild(popular.cloneNode(true));
      live.hidden = false;
      fallback.hidden = true;
    } catch (err) {
      if (err.name !== 'AbortError') showDefault();
    } finally {
      drop.classList.remove('is-loading');
    }
  }

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearBtn.hidden = !q;
    clearTimeout(timer);
    if (!q) { if (controller) controller.abort(); showDefault(); return; }
    timer = setTimeout(() => search(q), 180);
  });

  clearBtn.addEventListener('click', () => {
    input.value = '';
    showDefault();
    input.focus();
  });

  // Popular search chips fill the field and search in place.
  drop.addEventListener('click', e => {
    const chip = e.target.closest('[data-search-term]');
    if (!chip) return;
    e.preventDefault();
    input.value = chip.dataset.searchTerm;
    input.dispatchEvent(new Event('input'));
    input.focus();
  });

  document.addEventListener('click', e => {
    const t = e.target.closest('[data-search-toggle]');
    if (t) {
      e.preventDefault();
      isOpen() ? close() : open();
      return;
    }
    if (e.target.closest('[data-search-close]')) { close(); return; }
    if (isOpen() && !e.target.closest('[data-search-drop]')) close();
  });

  // Opening the mega menu closes search.
  document.addEventListener('click', e => { if (e.target.closest('[data-mega-toggle]')) close(); }, true);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && isOpen()) { close(); return; }
    // "/" opens search, like most stores and docs sites.
    if (e.key === '/' && !isOpen() && !/input|textarea|select/i.test(document.activeElement.tagName) && !document.activeElement.isContentEditable) {
      e.preventDefault();
      open();
    }
  });

  // Arrow keys move between results.
  drop.addEventListener('keydown', e => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    const items = [...drop.querySelectorAll('#SearchDropResults a:not([hidden])')].filter(a => a.offsetParent);
    if (!items.length) return;
    e.preventDefault();
    const i = items.indexOf(document.activeElement);
    const next = e.key === 'ArrowDown' ? (i + 1) % items.length : (i <= 0 ? -1 : i - 1);
    if (next === -1) input.focus(); else items[next].focus();
  });
})();
